import styled from 'styled-components';

export const DynamicHeaderWrapper = styled.div`
    color: ${({ theme }) => theme.Colors.Aliases.textDarkSecondary};
`;

export default DynamicHeaderWrapper;
